// @ts-nocheck
import Notification from "../util/Notification/Notification";
import { handleStackTraceException } from "./stackTraceHandle";
import { getMainStore } from "@cuba-platform/react";

type LocalizedException = {
  details: string
};


const handleLocalisedException = (e: LocalizedException) => {
    Notification.error({
      message: e.details
    });
}

const UNAUTHORIZED_HTTP_STATUS = 401;

export function makeFetchWrapper() {
  const originalFetch = window.fetch;
  window.fetch = async function(url, options) {
    const resp = await originalFetch(url, options);

    if (resp.status === UNAUTHORIZED_HTTP_STATUS) {
      let mainStore = getMainStore();

      if (mainStore.authenticated && mainStore.initialized) {
        window.location.reload();
      }
    }

    if (resp.headers.get("Content-Type") !== "application/json") {
      return resp;
    }

    if (!resp.ok) {
      const error = await resp.json();

      if (error._isLocalized) {
        handleLocalisedException(error);
      }
      if (error._isStacktrace) {
        handleStackTraceException(error);
      }
    }

    return resp;
  }
}
